import { createApp } from "vue";
import RpnAdminEditor from "./components/RpnAdminEditor.vue";
import { parseBoolean } from "./utils/parseBoolean";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-rpn-admin-editor]";

export function initRpnAdminEditorApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(RpnAdminEditor, {
      initialState: payload.initialState || {},
      subjectOptionsByGroup:
        payload.subjectOptionsByGroup && typeof payload.subjectOptionsByGroup === "object"
          ? payload.subjectOptionsByGroup
          : {},
      formId: payload.formId || "",
      canEdit: parseBoolean(payload.canEdit),
      isAddMode: parseBoolean(payload.isAddMode),
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
